import { Component, Inject, Input, OnInit } from "@angular/core";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { forkJoin } from "rxjs";
import { CommonService } from "src/app/services/common.service";
import { GlobalVariable } from "../../app.component";
import { DataService, Response } from "../../dataService/data.service";

@Component({
  selector: "app-review-statistics",
  templateUrl: "./review-statistics.component.html",
  styleUrls: ["./review-statistics.component.scss"],
})
export class ReviewStatisticsComponent implements OnInit {
  @Input() before_join_zceppa: any;
  @Input() isTotalReviewAvailable: boolean;
  public loading = false;
  private BASE_URL = GlobalVariable;
  outletId: string;
  reviewReceived: any;
  reviewByMom: any;
  beforeJoinZceppa: any = {};
  beforeZceppaRating: number;
  afterZceppaRating: number;
  view: any;
  chartData: any = [];
  myColors: any = [];

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private commonService: CommonService,
    private httpService: DataService
  ) {
    if (window.innerWidth < 768) {
      this.view = [innerWidth / 1.2, 250];
    } else {
      this.view = [innerWidth / 3.0, 250];
    }
  }

  ngOnInit() {
    this.loading = true;
    let res: Response;
    this.outletId = this.storage.get("outlet_id");
    const review_stats = this.httpService.get(
      this.BASE_URL.OVERALL_MONTHLY_REVIEW_URL(this.outletId)
    );

    review_stats.subscribe((result) => {
      this.loading = false;
      if (result.code == 200) {
        this.reviewReceived = result.data["reviews_received"];
        this.reviewByMom = Math.round(result.data["mom"]);
        this.beforeJoinZceppa = this.before_join_zceppa.data;
        var monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        var today = this.commonService.getDate();
        var d: Date;
        var month;
        this.chartData = [];
        for (var i = 6; i >= 0; i -= 1) {
          d = new Date(today.getFullYear(), today.getMonth() - i, 1);
          month = monthNames[d.getMonth()];
          this.chartData.push({
            name: month.substring(0, 3),
            series: [
              {
                name: "Request sent",
                value: 0,
              },
              {
                name: "Review received",
                value: this.reviewReceived[month],
              },
            ],
          });
        }

        this.myColors = [
          { name: "Request sent", value: "#EAEAEA" },
          { name: "Review received", value: "#03c0c2" },
        ];
      }
    });

    // const data_value = this.httpService.get(this.BASE_URL.BEFORE_JOIN_ZCEPPA(this.outletId));
    // data_value.subscribe((data: Response) => {
    //   res = data;
    if (
      this.before_join_zceppa.data[
        "google_overall_rating_before_zceppa_integration"
      ] !== 0 &&
      this.before_join_zceppa.data[
        "facebook_count_for_before_zceppa_integration"
      ] !== 0
    ) {
      this.beforeZceppaRating =
        (this.before_join_zceppa.data[
          "google_overall_rating_before_zceppa_integration"
        ] +
          this.before_join_zceppa.data[
            "facebook_count_for_before_zceppa_integration"
          ]) /
        2;
    } else {
      this.beforeZceppaRating =
        this.before_join_zceppa.data[
          "google_overall_rating_before_zceppa_integration"
        ] +
        this.before_join_zceppa.data[
          "facebook_count_for_before_zceppa_integration"
        ];
    }

    if (
      this.before_join_zceppa.data["google_overall_rating"] !== 0 &&
      this.before_join_zceppa.data["facebook_overall_rating"] !== 0 &&
      this.before_join_zceppa.data["zceppa_rating"] !== 0
    ) {
      this.afterZceppaRating =
        (this.before_join_zceppa.data["google_overall_rating"] +
          this.before_join_zceppa.data["facebook_overall_rating"] +
          this.before_join_zceppa.data["zceppa_rating"]) /
        3;
    } else if (
      this.before_join_zceppa.data["google_overall_rating"] !== 0 &&
      this.before_join_zceppa.data["facebook_overall_rating"] !== 0 &&
      this.before_join_zceppa.data["zceppa_rating"] === 0
    ) {
      this.afterZceppaRating =
        (this.before_join_zceppa.data["google_overall_rating"] +
          this.before_join_zceppa.data["facebook_overall_rating"] +
          this.before_join_zceppa.data["zceppa_rating"]) /
        2;
    } else if (
      this.before_join_zceppa.data["google_overall_rating"] !== 0 &&
      this.before_join_zceppa.data["facebook_overall_rating"] === 0 &&
      this.before_join_zceppa.data["zceppa_rating"] !== 0
    ) {
      this.afterZceppaRating =
        (this.before_join_zceppa.data["google_overall_rating"] +
          this.before_join_zceppa.data["facebook_overall_rating"] +
          this.before_join_zceppa.data["zceppa_rating"]) /
        2;
    } else if (
      this.before_join_zceppa.data["google_overall_rating"] === 0 &&
      this.before_join_zceppa.data["facebook_overall_rating"] !== 0 &&
      this.before_join_zceppa.data["zceppa_rating"] !== 0
    ) {
      this.afterZceppaRating =
        (this.before_join_zceppa.data["google_overall_rating"] +
          this.before_join_zceppa.data["facebook_overall_rating"] +
          this.before_join_zceppa.data["zceppa_rating"]) /
        2;
    } else {
      this.afterZceppaRating =
        this.before_join_zceppa.data["google_overall_rating"] +
        this.before_join_zceppa.data["facebook_overall_rating"] +
        this.before_join_zceppa.data["zceppa_rating"];
    }
    // });
  }
}
